import { render, staticRenderFns } from "./ComponentsTables.vue?vue&type=template&id=4c8d6174&"
import script from "./ComponentsTables.vue?vue&type=script&lang=js&"
export * from "./ComponentsTables.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsTables.vue?vue&type=style&index=0&id=4c8d6174&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports